module.exports = __webpack_public_path__ + "static/img/p8-5.599e606.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/p8-5.jpg
// module id = ynmX
// module chunks = 1